import fastdom from 'fastdom';
import { component } from 'picoapp';

export default component((node: HTMLFormElement) => {
  const filterGroup = node.querySelectorAll<HTMLElement>('[data-filter-group]');

  filterGroup.forEach((group) => {
    const filterGroupDisplay = group.querySelector<HTMLElement>('[data-filter-group-display]');
    const filterGroupSummaryLabel = group.querySelector<HTMLElement>('[data-filter-group-summary-label]');
    const filterGroupDisplayList = group.querySelector<HTMLElement>('[data-filter-group-display-list]');

    group.addEventListener('toggle', () => {
      if (group.hasAttribute('open')) {
        filterGroupDisplay?.classList.add('active');
        filterGroupSummaryLabel?.classList.add('active');

        filterGroup.forEach((otherGroup) => {
          if (otherGroup !== group) {
            otherGroup.removeAttribute('open');
          }
        });
      } else {
        filterGroupDisplay?.classList.remove('active');
        filterGroupSummaryLabel?.classList.remove('active');
      }

      // if group has open attribute close all other groups

      // Creating height property for each display
      fastdom.mutate(() => {
        const height = !filterGroupDisplay?.classList.contains('active') ? 0 : filterGroupDisplay?.scrollHeight;

        filterGroupDisplay.style.height = `${height}px`;
        filterGroupDisplay.setAttribute('aria-hidden', `${filterGroupDisplay.getAttribute('aria-hidden') === 'true' ? 'false' : 'true'}`);
        group.setAttribute('aria-expanded', `${group.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'}`);
      });
    });

    // on filterGroupDisplayList divide its children by 3 and add its result as column count style
    if (filterGroupDisplayList) {
      const childrenCount = filterGroupDisplayList.children.length;
      const columnCount = Math.ceil(childrenCount / 4);

      filterGroupDisplayList.style.columnCount = `${columnCount}`;
    }
  });
});
